import { cn } from '@/lib/utils';
import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
  className?: string;
  /** `dark` para usarlo sobre las bandas de cacao. */
  tone?: 'light' | 'dark';
}

/** Eyebrow: el único lugar de la página donde se usan mayúsculas espaciadas. */
export function SectionTag({
  children,
  className = '',
  tone = 'light'
}: SectionTagProps) {
  return <span className={cn('inline-flex items-center gap-2.5 rounded-full py-1.5 pl-2.5 pr-4 text-[0.6rem] font-bold uppercase tracking-editorial sm:text-[0.66rem]', tone === 'dark' ? 'bg-white/15 text-white' : 'bg-gold-pale text-gold-deep', className)} data-id="element-303" data-mp="2apcc8wlmlgit">
      <span className={cn('h-1.5 w-1.5 rounded-full', tone === 'dark' ? 'bg-white' : 'bg-pistacho')} aria-hidden data-id="element-304" data-mp="2oghdg34n6gv9" />
      {children}
    </span>;
}